import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loading-icon" }

import { toRefs } from "vue";
import VueFeather from "vue-feather";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingSpinner',
  props: {
    size: {}
  },
  setup(__props: any) {

const props = __props;

const { size } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VueFeather), {
      size: _unref(size),
      class: "spin",
      type: "loader"
    }, null, 8, ["size"])
  ]))
}
}

})